(function() {
  'use strict';

  function preloadSizeGuideImages() {
    const sizeGuideModals = document.querySelectorAll('[data-popup-id*="size-guide"]');
    
    sizeGuideModals.forEach(modal => {
      const images = modal.querySelectorAll('.variant-popup-modal__image img');
      images.forEach(img => {
        if (img.src && !img.complete) {
          const preloadImg = new Image();
          preloadImg.src = img.src;
        }
      });
    });
  }

  function initVariantPopups() {
    preloadSizeGuideImages();
    
    const triggers = document.querySelectorAll('[data-popup-trigger]');
    
    triggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const popupId = this.getAttribute('data-popup-trigger');
        const popup = document.querySelector(`#popup-${popupId}`);
        
        if (popup) {
          const images = popup.querySelectorAll('.variant-popup-modal__image img');
          const imagePromises = Array.from(images).map(img => {
            if (img.complete) {
              return Promise.resolve();
            }
            return new Promise((resolve, reject) => {
              img.onload = resolve;
              img.onerror = resolve;
              if (!img.src) {
                resolve();
              }
            });
          });
          
          Promise.all(imagePromises).then(() => {
            openPopup(popup);
          });
        }
      });
    });

    const closeButtons = document.querySelectorAll('.variant-popup-modal__close');
    closeButtons.forEach(button => {
      button.addEventListener('click', function() {
        const popup = this.closest('.variant-popup-modal');
        if (popup) {
          closePopup(popup);
        }
      });
    });

    // Close on overlay click
    const overlays = document.querySelectorAll('.variant-popup-modal__overlay');
    overlays.forEach(overlay => {
      overlay.addEventListener('click', function() {
        const popup = this.closest('.variant-popup-modal');
        if (popup) {
          closePopup(popup);
        }
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const openPopups = document.querySelectorAll('.variant-popup-modal--open');
        openPopups.forEach(popup => {
          closePopup(popup);
        });
      }
    });
  }

  function openPopup(popup) {
    if (!popup) return;
    
    const tidioChat = document.getElementById('tidio-chat-root');
    if (tidioChat) {
      tidioChat.style.zIndex = '1';
    }
    
    popup.classList.add('variant-popup-modal--open');
    document.body.style.overflow = 'hidden';
    
    const firstFocusable = popup.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) {
      firstFocusable.focus();
    }
  }

  function closePopup(popup) {
    if (!popup) return;
    
    const container = popup.querySelector('.variant-popup-modal__container');
    if (container && window.innerWidth <= 768) {
      container.style.transform = 'translateY(100%)';
      setTimeout(() => {
        popup.classList.remove('variant-popup-modal--open');
        document.body.style.overflow = '';
        container.style.transform = '';
        
        const tidioChat = document.getElementById('tidio-chat-root');
        if (tidioChat) {
          tidioChat.style.zIndex = '';
        }
      }, 300);
    } else {
      popup.classList.remove('variant-popup-modal--open');
      document.body.style.overflow = '';
      
      const tidioChat = document.getElementById('tidio-chat-root');
      if (tidioChat) {
        tidioChat.style.zIndex = '';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantPopups);
  } else {
    initVariantPopups();
  }
})();

